export const LocalStorageKeys = {
  Language: "lan",
  Access: "access",
  ViewMode: "viewMode",
};
